import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { ImportedEmployment } from './imported-employment.interface';
import { ImportedEmploymentService } from './imported-employment.service';

const service = new ImportedEmploymentService();

export interface ImportedEmploymentState {
   count: number;
}

const ImportedEmploymentStore: Module<ImportedEmploymentState, StoreState> = {
   namespaced: true,
   state: {
      count: 0,
   },
   getters: {},
   mutations: {
      SET_COUNT(state, count: number) {
         state.count = count;
      },
   },
   actions: {
      async getImportedEmployments(context, query?: LocationQuery) {
         return await service.getImportedEmployments(query);
      },
      async changeImportedEmployments(context, payload: { importedEmployments: Array<ImportedEmployment>; query?: LocationQuery }) {
         return await service.putImportedEmployment(payload.importedEmployments, payload.query);
      },
      async removeImportedEmployment(context, id: number) {
         return await service.deleteImportedEmployment(id);
      },
      async getImportedEmploymentsCount(context) {
         const count = await service.getImportedEmploymentsCount();
         context.commit('SET_COUNT', count);
         return count;
      },
   },
};

export default ImportedEmploymentStore;
